var exports = {
  "x6": "TextareaButton.module__button___cUN1NU",
  "DY": "TextareaButton.module__contextMenuHover___cUN1NU",
  "wH": "TextareaButton.module__selected___cUN1NU",
  "Kk": "TextareaButton.module__icon___cUN1NU",
  "w": "TextareaButton.module__buttonCompact___cUN1NU" + " " + "TextareaButton.module__button___cUN1NU",
};

module.exports = exports;
